import { CATEGORY_TYPE } from '@/helpers/types'

export const DefaultContent = Object.freeze({
  [CATEGORY_TYPE.WELCOME]: "Hi, Welcome to the team! It's great to have you on board!",

  [CATEGORY_TYPE.THANKYOU]:
`The text below is meant to help you craft a meaningful message.

3 templates you can customize
1- Thank you for attitude
Hi, thank you so much for your help during the Women 2.0 trade show. You really came through, showing what it means to be a "team player.” You have helped to make things run smoothly. Your positive attitude has made a big difference in the way the rest of the team has viewed the coming changes.

2- Thank you for the extra effort
Hi, thank you for making the presentation to Google when Ericka was stuck at the airport. It was an opportunity that we couldn't miss!

3 -Thank you for exceptional proactivity.
Thank you for saving us by catching a million dollar error in the budget!
`,

  [CATEGORY_TYPE.FEEDBACK]:
`The text below is meant to help you craft a meaningful message.
Tips to give great feedback
- Don't wait - Because you lose your power and positive impact by providing feedback too late. Also, it's impossible to improve if you are unaware of the mistake or need some adjustments.
- Be respectful - Always process information before delivering it. Don't share guidance in public.
- Be assertive - use direct but tactful communication by communicating clear messages in a calm and controlled manner.

2 templates you can customize
1 - Feedback ask for 1-1 meeting
Hi, I wanted to take the time to discuss the presentation at the client's office yesterday. It was a great learning experience to find out the principal motivation for their decision. I would like to discuss that at our next 1-1 meeting tomorrow.

2 - Feedback give a specific reason why it was great
Hi, I wanted to emphasize that your last report was stellar! It covered all the topics that I needed to cover at my meeting with the CEO. I shared it with the team as an example for the future.`,

  [CATEGORY_TYPE.COACHING]:
`The text below is meant to help you craft a meaningful message.
Tips for being a great coach
- Start by working on awareness-raising: the why something needs to be changed
- Take your coach posture by always communicating your desire to help the person improve to be successful on the job
- Ask how your co-worker sees the next steps before giving some guidance. A coach always breaks down what is needed to be done as reasonable next steps.

2 templates you can customize
1 - Feedback to help to inspire a change
Hi, You were in charge of the Nasa project for the last 6 months. You have done very well and should have felt empowered to speak up more when it was under discussion. You should take credit for the work you did! I want to support you and coach you towards that starting today.

2- Offering your help
Hi, I wanted to follow up on our latest project. I noticed a few things that I could help you with for the next project. I wonder if you'd like me to break down what I have been learning so far. Please let me know if I can be of any help.
`
})

export const GiveKudo =
`The text below is meant to help you craft a meaningful message.
Tips for giving meaningful kudos
- Kudos that include specific details and examples of the reason for the appreciation carry more weight than broadly framed appreciation.

1 template you can customize
Thank you for taking the lead in organizing all the project managers' efforts to deliver the Harley-Davidson tradeshow. It was beyond the scope of your responsibilities and greatly appreciated by all.`

export const sayHiDefaultMessage = name => `Hi ${name}, welcome to the team! It's great to have you onboard.`
